/* ============================================================
   Crawler Madness — nav-page behaviors, duplicated 1:1 from the concept build's
   site.js (docs/PAGES_PLAN.md): scroll-reveal, stat counters, the clip reel, the
   fade slideshows, and the modular floor-plan configurator (window.CM_PLAN).
   Loaded ONLY on the nav-page templates. The slideshow hooks are renamed
   data-slides -> data-pslides so they don't collide with the homepage theme.js
   slider (which owns [data-slides]). Crawler Madness only.
   ============================================================ */
(function () {
  'use strict';

  /* ---------- scroll reveal ---------- */
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var rv = document.querySelectorAll('.cmpg .rv, .cmpg .stg, .cmpg .shead');
  if (reduce || !('IntersectionObserver' in window)) {
    Array.prototype.forEach.call(rv, function (el) { el.classList.add('in'); });
  } else {
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -6% 0px', threshold: 0.04 });
    Array.prototype.forEach.call(rv, function (el) { io.observe(el); });
  }

  /* ---------- stat counters ---------- */
  var counters = document.querySelectorAll('.cmpg [data-count]');
  if (counters.length) {
    if (reduce || !('IntersectionObserver' in window)) {
      // leave the final numbers in place
    } else {
      var cio = new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          if (!e.isIntersecting) return;
          cio.unobserve(e.target);
          var el = e.target;
          var full = el.textContent;
          var target = parseInt(el.getAttribute('data-count'), 10);
          if (isNaN(target) || target === 0) return;
          var prefix = full.slice(0, full.indexOf(String(target)));
          var suffix = full.slice(prefix.length + String(target).length);
          var dur = 900, t0 = null;
          function step(ts) {
            if (t0 === null) t0 = ts;
            var k = Math.min(1, (ts - t0) / dur);
            var eased = 1 - Math.pow(1 - k, 3);
            el.textContent = prefix + Math.round(target * eased) + suffix;
            if (k < 1) requestAnimationFrame(step);
            else el.textContent = full;
          }
          el.textContent = prefix + '0' + suffix;
          requestAnimationFrame(step);
        });
      }, { threshold: 0.4 });
      Array.prototype.forEach.call(counters, function (c) { cio.observe(c); });
    }
  }

  /* ---------- clip reel ---------- */
  Array.prototype.forEach.call(document.querySelectorAll('.cmpg [data-reel]'), function (reel) {
    var clips = reel.querySelectorAll('.clip');
    if (!clips.length) return;

    function live() {
      if (reduce) return;
      var vl = reel.scrollLeft, vr = vl + reel.clientWidth, mid = vl + reel.clientWidth / 2;
      var best = 0, bestD = Infinity;
      Array.prototype.forEach.call(clips, function (el, i) {
        var d = Math.abs((el.offsetLeft + el.offsetWidth / 2) - mid);
        if (d < bestD) { bestD = d; best = i; }
      });
      Array.prototype.forEach.call(clips, function (el, i) {
        var v = el.querySelector('video');
        // Play EVERY clip that's in the reel's viewport (not just the centered one)
        // so a wall of clips all move; `.playing` shows each clip's video, while the
        // centered clip alone keeps the accent ring + scale via `.live`. Off-screen
        // clips pause to keep only visible videos decoding.
        var inView = (el.offsetLeft + el.offsetWidth) > vl + 8 && el.offsetLeft < vr - 8;
        el.classList.toggle('live', i === best);
        el.classList.toggle('playing', inView && !!v);
        if (!v) return;
        if (inView) {
          if (!v.src) { v.src = v.getAttribute('data-src'); }
          var pr = v.play(); if (pr && pr.catch) pr.catch(function () {});
        } else if (v.src) { v.pause(); }
      });
    }

    var r;
    reel.addEventListener('scroll', function () {
      cancelAnimationFrame(r); r = requestAnimationFrame(live);
    }, { passive: true });
    window.addEventListener('resize', live);

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          if (e.isIntersecting) live();
          else Array.prototype.forEach.call(clips, function (el) {
            var v = el.querySelector('video'); if (v && v.src) v.pause();
          });
        });
      }, { threshold: 0.25 }).observe(reel);
    } else { live(); }

    var down = false, sx = 0, sl = 0;
    reel.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'touch') return;
      down = true; sx = e.clientX; sl = reel.scrollLeft; reel.classList.add('dragging');
    });
    reel.addEventListener('pointermove', function (e) {
      if (down) reel.scrollLeft = sl - (e.clientX - sx);
    });
    function up() { if (down) { down = false; reel.classList.remove('dragging'); live(); } }
    reel.addEventListener('pointerup', up);
    reel.addEventListener('pointerleave', up);
  });

  /* ---------- slideshows (renamed hooks: data-pslides*) ---------- */
  Array.prototype.forEach.call(document.querySelectorAll('.cmpg [data-pslides]'), function (box) {
    var imgs = box.querySelectorAll('img');
    if (imgs.length < 2) return;
    var wrap = box.parentNode;
    var dots = wrap.querySelector('[data-pslides-dots]');
    var count = box.querySelector('[data-pslides-count]');
    var dotBtns = dots ? dots.querySelectorAll('button') : [];
    var i = 0, timer = null, hovered = false, onScreen = !('IntersectionObserver' in window);

    function pad(n) { return (n < 10 ? '0' : '') + n; }

    function show(next) {
      i = (next + imgs.length) % imgs.length;
      Array.prototype.forEach.call(imgs, function (im, n) { im.classList.toggle('on', n === i); });
      Array.prototype.forEach.call(dotBtns, function (d, n) {
        d.setAttribute('aria-current', String(n === i));
      });
      if (count) count.textContent = pad(i + 1) + '/' + pad(imgs.length);
    }

    // (Re)starts the loop from the current slide, so a picked slide gets a full interval.
    // It runs while the gallery is on screen and no mouse rests on it. A dot press used to
    // stop it for good; every slideshow now keeps looping (Peter, 2026-09-27).
    function start() {
      stop();
      if (reduce || hovered || !onScreen) return;
      timer = setInterval(function () { show(i + 1); }, 4200);
    }
    function stop() { clearInterval(timer); timer = null; }

    Array.prototype.forEach.call(dotBtns, function (d, n) {
      d.addEventListener('click', function () { show(n); start(); });
    });
    // Pause while a MOUSE rests on the gallery. Touch is ignored: phones fake mouse events
    // on every tap and end the fake hover only on a tap elsewhere, which stopped the loop.
    wrap.addEventListener('pointerenter', function (e) { if (e.pointerType === 'mouse') { hovered = true; stop(); } });
    wrap.addEventListener('pointerleave', function (e) { if (e.pointerType === 'mouse') { hovered = false; start(); } });

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) {
        es.forEach(function (e) { onScreen = e.isIntersecting; start(); });
      }, { threshold: 0.15 }).observe(box);
    } else { start(); }
  });

  /* ---------- modular layout plan ---------- */
  var cfgs = window.CM_PLAN;
  var tabs = document.querySelector('.cmpg [data-plan-tabs]');
  var plan = document.querySelector('.cmpg [data-plan]');
  var cap  = document.querySelector('.cmpg [data-plan-cap]');
  var bar  = document.querySelector('.cmpg [data-plan-bar]');
  var stage = document.querySelector('.cmpg .plan-stage');
  var PLAN_MAXW = 760, PLAN_MAXH = 440;

  var PLAN_ICONS = {
    stack3: '<rect x="3" y="4" width="18" height="4"/><rect x="3" y="10" width="18" height="4"/><rect x="3" y="16" width="18" height="4"/>',
    stack2: '<rect x="3" y="6" width="18" height="5"/><rect x="3" y="13" width="18" height="5"/>',
    stack1: '<rect x="6" y="5" width="12" height="14"/>'
  };

  /* top-view branch ladder for a rope segment (feet): wavy rails + irregular rungs, transparent between */
  function ropeSVG(w, h) {
    var horiz = w >= h, L = horiz ? w : h, T = horiz ? h : w;
    function rnd(i) { var s = Math.sin((i + 1) * 17.13) * 43758.55; return s - Math.floor(s); }
    function P(a, c) { return horiz ? (a.toFixed(2) + ' ' + c.toFixed(2)) : (c.toFixed(2) + ' ' + a.toFixed(2)); }
    var railA = T * 0.17, railB = T * 0.83, steps = Math.max(4, Math.round(L / 0.7));
    function rail(base, seed) {
      var d = '';
      for (var i = 0; i <= steps; i++) { d += (i ? ' L ' : 'M ') + P(L * i / steps, base + (rnd(i + seed) - 0.5) * T * 0.22); }
      return '<path d="' + d + '" fill="none" stroke="#C79154" stroke-width="2.3" vector-effect="non-scaling-stroke" stroke-linecap="round"/>';
    }
    var n = Math.max(2, Math.round(L / 1.05)), rungs = '';
    for (var j = 1; j < n; j++) {
      var a0 = L * j / n + (rnd(j + 40) - 0.5) * (L / n) * 0.6; if (a0 < 0.12) a0 = 0.12; if (a0 > L - 0.12) a0 = L - 0.12;
      var a1 = a0 + (rnd(j + 60) - 0.5) * 0.35;
      var p1 = P(a0, railA + (rnd(j + 80) - 0.5) * T * 0.1).split(' ');
      var p2 = P(a1, railB + (rnd(j + 95) - 0.5) * T * 0.1).split(' ');
      rungs += '<line x1="' + p1[0] + '" y1="' + p1[1] + '" x2="' + p2[0] + '" y2="' + p2[1] + '" stroke="#DBAA69" stroke-width="1.9" vector-effect="non-scaling-stroke" stroke-linecap="round"/>';
    }
    return '<svg class="ropesvg" viewBox="0 0 ' + w + ' ' + h + '" preserveAspectRatio="none" aria-hidden="true">' + rail(railA, 3) + rail(railB, 120) + rungs + '</svg>';
  }

  if (cfgs && cfgs.length && tabs && plan) {
    var current = 0;

    cfgs.forEach(function (c, i) {
      var b = document.createElement('button');
      b.className = 'cfg-tab';
      b.type = 'button';
      b.setAttribute('role', 'tab');
      b.setAttribute('aria-selected', String(i === current));
      b.innerHTML = (c.icon && PLAN_ICONS[c.icon] ? '<svg viewBox="0 0 24 24" aria-hidden="true">' + PLAN_ICONS[c.icon] + '</svg>' : '') +
                    '<span><b>' + c.name + '</b>' + c.sub + '</span>';
      b.addEventListener('click', function () { draw(i); });
      tabs.appendChild(b);
    });

    function draw(i) {
      current = i;
      var c = cfgs[i], W = c.room[0], H = c.room[1];
      Array.prototype.forEach.call(tabs.children, function (t, n) {
        t.setAttribute('aria-selected', String(n === i));
      });
      if (stage) stage.style.maxWidth = Math.min(PLAN_MAXW, Math.round(PLAN_MAXH * W / H)) + 'px';
      plan.style.paddingBottom = (H / W * 100) + '%';
      plan.style.setProperty('--grid', (1 / W * 200) + '%');
      plan.innerHTML = c.blocks.map(function (b) {
        var inner = b.t === 'rope' ? ropeSVG(b.w, b.h) : (b.l || '');
        return '<div class="blk-m m-' + b.t + (b.v != null ? ' zv' + b.v : '') + '" style="left:' + (b.x / W * 100) +
          '%;top:' + (b.y / H * 100) + '%;width:' + (b.w / W * 100) +
          '%;height:' + (b.h / H * 100) + '%">' + inner + '</div>';
      }).join('');
      if (cap) cap.innerHTML = c.cap;
      if (bar) bar.style.width = Math.max(24, Math.round(plan.clientWidth * 10 / W)) + 'px';
    }

    draw(current);

    var rt;
    window.addEventListener('resize', function () {
      clearTimeout(rt);
      rt = setTimeout(function () { draw(current); }, 150);
    });
  }

  /* ---------- rotating headline word (.rot[data-rot]) ---------- */
  /* Second line of a hero cycles through a JSON list of words. The word sits in
     a .slot; toggling .swap on .rot fades/lifts it (CSS .28s), we replace the
     text mid-fade, then fade back in. The .rot underline (::after) resizes to
     each word since .rot is inline-block + nowrap. Honors reduced-motion. */
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  // Honor *asterisk* accents in rotating words too (matches snippets/accent.liquid):
  // a *…*-wrapped run becomes an orange <span class="em">…</span>; other text is escaped.
  function accentHTML(s) {
    var parts = String(s == null ? '' : s).split('*');
    var out = '';
    for (var k = 0; k < parts.length; k++) {
      var esc = parts[k].replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
      out += (k % 2 === 1) ? '<span class="em">' + esc + '</span>' : esc;
    }
    return out;
  }
  Array.prototype.forEach.call(document.querySelectorAll('.cmpg .rot[data-rot]'), function (rot) {
    var slot = rot.querySelector('.slot');
    if (!slot) return;
    var words;
    try { words = JSON.parse(rot.getAttribute('data-rot')); } catch (e) { words = null; }
    if (!words || words.length < 2 || reduce) return;
    var i = 0;
    var hold = parseInt(rot.getAttribute('data-rot-hold'), 10) || 2400;
    setInterval(function () {
      rot.classList.add('swap');
      setTimeout(function () {
        i = (i + 1) % words.length;
        slot.innerHTML = accentHTML(words[i]);
        rot.classList.remove('swap');
      }, 280);
    }, hold);
  });

  /* ---------- pop-up dates: a date that has passed moves to "Past Events" (theme 1.33.0) ----------
     The theme sorts dates with Liquid's 'now', which Shopify may serve from a cached render, so
     re-check each upcoming date's last day against the visitor's own date. */
  var dlNow = new Date();
  var dlPad = function (n) { return (n < 10 ? '0' : '') + n; };
  var dlToday = dlNow.getFullYear() + '-' + dlPad(dlNow.getMonth() + 1) + '-' + dlPad(dlNow.getDate());
  Array.prototype.forEach.call(document.querySelectorAll('.cmpg [data-dates]'), function (wrap) {
    var up = wrap.querySelector('[data-upcoming]');
    var past = wrap.querySelector('[data-past]');
    var group = wrap.querySelector('.past-dates');
    if (!up || !past || !group) return;
    var moved = 0;
    Array.prototype.forEach.call(up.querySelectorAll('li[data-last]'), function (li) {
      if (li.getAttribute('data-last') >= dlToday) return;
      li.classList.add('is-done');
      var when = li.querySelector('.when');
      if (!when) { when = document.createElement('div'); when.className = 'when'; li.appendChild(when); }
      when.textContent = 'Finished';
      // keep the order the dates are listed in
      var i = +li.getAttribute('data-i');
      var before = null;
      Array.prototype.some.call(past.children, function (p) {
        if (+p.getAttribute('data-i') > i) { before = p; return true; }
        return false;
      });
      past.insertBefore(li, before);
      moved++;
    });
    if (!moved) return;
    group.hidden = false;
    if (!up.querySelector('li')) {
      up.hidden = true;
      var empty = wrap.querySelector('.dates-empty');
      if (empty) empty.hidden = false;
    }
  });
})();
